import { Particle, type ParticleOptions } from "../Particle";
import { MovesUp } from "../behaviors/MovesUp";
import { Lifetime } from "../behaviors/Lifetime";
import { adjustColor } from "../../utils/color";

export class Smoke extends Particle {
    static colors = [
        0x555555,
        0x666666,
        0x777777,
        0x444444
    ];

    constructor(options: Partial<ParticleOptions> = {}) {
        const baseColor = Smoke.colors[Math.floor(Math.random() * Smoke.colors.length)] ?? 0x555555;
        super({
            name: "Smoke",
            color: adjustColor(baseColor, 10),
            behaviors: [
                new MovesUp(),
                new Lifetime(8, 35) // 缩短寿命，减少持续时间
            ],
            temperature: 5,
            minTemp: 20,
            maxTemp: 1000,
            ...options
        });
    }
}
